/**
 * UForm text encoder (ticket 07) — isomorphic: the same class runs under Node
 * and in the browser, both via `onnxruntime-web` WASM. Produces a raw (non
 * L2-normalized) 256-dim embedding; callers normalize with
 * `@egalregal/shared`'s `normalizeVector` before cosine (tickets 02/04).
 */
import { MAX_SEQUENCE_LENGTH } from "./config.js";
import { createSession, embeddingsTensor, tensorToVector, Tensor } from "./session.js";
import { createTextTokenizer } from "./tokenizer.js";
/**
 * Text → 256-dim UForm embedding. Lazy: call {@link UformTextEncoder.create}
 * once (loads the session + tokenizer), then {@link encode} as many times as
 * needed. Call {@link dispose} when done to release the session.
 */
export class UformTextEncoder {
    session;
    tokenize;
    constructor(session, tokenize) {
        this.session = session;
        this.tokenize = tokenize;
    }
    static async create(options) {
        const session = await createSession(options.model);
        const tokenize = createTextTokenizer(options.tokenizerJson);
        return new UformTextEncoder(session, tokenize);
    }
    /** Embed a single text (German or English) into a raw 256-dim vector. */
    async encode(text) {
        const { inputIds, attentionMask } = this.tokenize(text);
        const inputIdsTensor = new Tensor("int32", new Int32Array(inputIds), [1, MAX_SEQUENCE_LENGTH]);
        const attentionMaskTensor = new Tensor("int32", new Int32Array(attentionMask), [
            1,
            MAX_SEQUENCE_LENGTH,
        ]);
        const outputs = await this.session.run({
            input_ids: inputIdsTensor,
            attention_mask: attentionMaskTensor,
        });
        return tensorToVector(embeddingsTensor(outputs));
    }
    async dispose() {
        await this.session.release();
    }
}
//# sourceMappingURL=text.js.map